module.exports = __webpack_public_path__ + "static/logo-dc69c8081dc68bef0d57a75d64a9504c.jpg";